export const WIZARD_FORM_NAME = 'wizard';
